import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizationDemoComponent } from './shared/components/localization-demo/localization-demo.component';
import { SuperAdminGuard } from './core/guards/super-admin.guard';
import { PermissionGuard } from './core/guards/permission.guard';
import { SitesListComponent } from './features/admin/sites/sites-list/sites-list.component';
import { TenantsListComponent } from './features/admin/tenants/tenants-list/tenants-list.component';
import { TenantFormComponent } from './features/admin/tenants/tenant-form/tenant-form.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'localization-demo',
    component: LocalizationDemoComponent,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'legal',
    loadChildren: () =>
      import('./features/legal/legal.module').then((m) => m.LegalModule),
  },
  {
    path: 'pos',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['sale.read', 'sale.create'] },
    loadChildren: () =>
      import('./features/pos/pos.module').then((m) => m.PosModule),
  },
  {
    path: 'products',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['product.read'] },
    loadChildren: () =>
      import('./features/products/products.module').then(
        (m) => m.ProductsModule,
      ),
  },
  {
    path: 'customers',
    canActivate: [PermissionGuard],
    data: {
      permissionsAny: ['customer.read', 'customer.loyalty.read'],
    },
    loadChildren: () =>
      import('./features/customers/customers.module').then(
        (m) => m.CustomersModule,
      ),
  },
  {
    path: 'inventory',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['inventory.read'] },
    loadChildren: () =>
      import('./features/inventory/inventory.module').then(
        (m) => m.InventoryModule,
      ),
  },
  {
    path: 'reports',
    canActivate: [PermissionGuard],
    data: {
      permissionsAny: [
        'report.sales',
        'report.inventory',
        'report.customers',
        'report.financial',
      ],
    },
    loadChildren: () =>
      import('./features/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'dashboard',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'users',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['user.management'] },
    loadChildren: () =>
      import('./features/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'settings',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['settings.read', 'settings.update'] },
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule,
      ),
  },
  {
    path: 'roles',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['role.read'] },
    loadChildren: () =>
      import('./features/roles/roles.module').then((m) => m.RolesModule),
  },
  {
    path: 'admin/audit-logs',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['audit.read'], title: 'Audit Logs' },
    loadChildren: () =>
      import('./features/admin/audit-logs/audit-logs.module').then(
        (m) => m.AuditLogsModule,
      ),
  },
  {
    path: 'admin/sites',
    canActivate: [PermissionGuard],
    data: { permissionsAny: ['user.management', 'settings.read'] },
    children: [
      {
        path: '',
        component: SitesListComponent,
        data: { title: 'Sites Management' },
      },
    ],
  },
  {
    path: 'admin/tenants',
    canActivate: [SuperAdminGuard],
    children: [
      {
        path: '',
        component: TenantsListComponent,
        data: { title: 'Tenants Management' },
      },
      {
        path: 'new',
        component: TenantFormComponent,
        data: { title: 'Create Tenant' },
      },
      {
        path: ':id/edit',
        component: TenantFormComponent,
        data: { title: 'Edit Tenant' },
      },
    ],
  },
  {
    path: 'profile',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./features/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
